import pigeon from '../../utilities/js/pigeon/pigeon.js';

class ProductsListPage {
  constructor(mainElement, name = 'products-list-page') {
    this.name = name;
    this.mainElement = mainElement;
    this.loaderId = this.mainElement.dataset.loaderId;
    this.bindEvents();
  }

  bindEvents() {
    pigeon.subscribe('productList:loadStart', this.loadStartHandler.bind(this));
    pigeon.subscribe('productList:loadComplete', this.loadCompleteHandler.bind(this));
    pigeon.subscribe('productList:error', this.errorHandler.bind(this));
  }


  loadStartHandler() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.showLoader();
    }, 50);
  }

  loadCompleteHandler({url, title, headline, breadCrumbHtml}) {
    clearTimeout(this.timeout);
    this.hideLoader();
    const productListPageName = document.querySelector('.products-list-page__name');
    const breadcrumbs = document.querySelector('.page-breadcrumbs');

    if (url) {
      window.history.replaceState(null, '', url);
    }
    if (title) {
      document.querySelector('title').textContent = title;
    }
    if (headline && productListPageName) {
      productListPageName.innerHTML = headline;
    }
    if (breadCrumbHtml && breadcrumbs) {
      breadcrumbs.innerHTML = breadCrumbHtml;
    }
  }

  errorHandler(error) {
    pigeon.publish('globalAppMessage:show', {error: error});
    this.hideLoader();
  }

  showLoader() {
    pigeon.publish('loader:show', {id: this.loaderId});
  }

  hideLoader() {
    pigeon.publish('loader:hide', {id: this.loaderId});
  }
}

export default ProductsListPage
